<template>
  <b-modal id="machine-file-history-modal" ref="machine-file-history-modal" hide-footer scrollable @hidden="filter = ''">
    <template #modal-title>
      <div>
        <h5 class="mb-0">Machine File Revisions</h5>
      </div>
    </template>
    <b-alert v-if="loadingError" show variant="danger">
      {{ loadingError }}
    </b-alert>
    <b-form-input
        v-model="filter"
        placeholder="Search revisions..."
        class="mb-3"
        autofocus
    ></b-form-input>
    <b-table :items="filteredEntries" :fields="fields" :sort-by="sortBy" :sort-desc="sortDesc" small striped class="mb-0">
      <template #cell(revision)="data">
        <router-link :to="'/machine-file/history/' + machineId + '/' + data.item.revision" target="_blank">
          <span class="font-weight-bold" v-if="data.item.revision === machineFileRevision">
            {{ data.value }} (current)
          </span>
          <span v-else>
            {{ data.value }}
          </span>
        </router-link>
      </template>
    </b-table>
  </b-modal>
</template>

<script>

import { machineFilesApi } from '@/backend'

export default {
  name: 'ModalMachineFileHistory',
  props: {
    machineId: {
      type: Number,
      required: true
    },
    machineFileRevision: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      fields: [
        { key: 'revision', label: 'Revision', sortable: true },
        { key: 'timestamp', label: 'Date', sortable: true },
        { key: 'author', sortable: true }
      ],
      machineFileEntries: [],
      loadingError: null,
      sortBy: 'revision',
      sortDesc: true,
      filter: ''
    }
  },
  computed: {
    filteredEntries () {
      const filter = this.filter.toLowerCase()
      return this.machineFileEntries.filter(entry =>
          (entry.revision ?? '').toString().toLowerCase().includes(filter) ||
          (entry.author ?? '').toLowerCase().includes(filter) ||
          (entry.timestamp ?? '').toString().toLowerCase().includes(filter)
      )
    }
  },
  methods: {
    show () {
      this.fetchMachineFileHistory()
      this.$refs['machine-file-history-modal'].show()
    },
    fetchMachineFileHistory () {
      machineFilesApi.getMachineFileHistory(this.machineId, (error, data) => {
        if (error) {
          console.error(error)
          this.loadingError = error
          return
        }
        this.machineFileEntries = data
      })
    }
  }
}
</script>

<style lang="scss">
#machine-file-history-modal {
  .modal-body {
    max-height: 70vh;
  }
}
</style>
